import { FC } from 'react';
import styles from './CopyRight.module.css';

export const CopyRight: FC = () => {
  return (
    <div className={styles.copyRight}>
      &copy;{' '}
      <a href="https://ubie.life/" target="_blank" rel="noopener">
        Ubie, Inc.
      </a>
    </div>
  );
};
